import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

export default function Space() {
  return (
    <section
      id="espaco"
      data-testid="space-section"
      className="py-24 md:py-36 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="lg:col-span-5">
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-neutral-400" />
              O meu espaço
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-black">
              Um refúgio no coração do Porto.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-base md:text-lg text-neutral-600 leading-relaxed max-w-xl">
              Ambiente sereno, iluminação natural e instrumentos esterilizados.
              Cada detalhe pensado para a sua experiência ser tão refinada
              quanto o resultado.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="relative aspect-square w-full bg-neutral-100 overflow-hidden"
            data-testid="space-image-1"
          >
            <img
              src={IMAGES.studio}
              alt="Estúdio Sena Beauty"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <span className="absolute bottom-4 left-4 text-white text-[10px] tracking-[0.3em] uppercase drop-shadow">
              Studio · Porto
            </span>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut", delay: 0.1 }}
            className="relative aspect-square w-full bg-neutral-100 overflow-hidden"
            data-testid="space-image-2"
          >
            <img
              src={IMAGES.studio2}
              alt="Sena Beauty Studio · Porto"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <span className="absolute bottom-4 right-4 font-serif italic text-white text-2xl md:text-3xl drop-shadow">
              &ldquo;atmosfera&rdquo;
            </span>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-6 md:mt-8">
          {[
            ["Higiene", "Materiais descartáveis e protocolo rigoroso de esterilização."],
            ["Privacidade", "Atendimento individual em horários reservados, sem fila de espera."],
            ["Conforto", "Maca ergonómica, música cuidada e bebida de cortesia."],
          ].map(([t, d]) => (
            <div key={t} className="border-t border-black/15 pt-6">
              <div className="font-serif text-2xl text-black">{t}</div>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
